import intl from 'react-intl-universal';
import { Typography } from '@getsynapse/design-system';
import { useTeamMembersManagement } from '../../hooks/useTeamMembersManagement/useTeamMembersManagement';
import AddMembers from './components/AddMembers/AddMembers';
import MembersTableList from './components/MembersTableList/MembersTableList';
import TeamMembersManagementNotifications from './components/TeamMembersManagementNotifications/TeamMembersManagementNotifications';

const TeamMembers = () => {
  const { addTeamMembers, learningTeamMembers, removeTeamMember } =
    useTeamMembersManagement();

  return (
    <div className='mt-8 flex flex-col gap-y-4'>
      <Typography variant='h5' className='text-neutral-black'>
        {intl.get('ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.TEAM_MEMBERS')}
      </Typography>
      <AddMembers onAddUsers={addTeamMembers} />
      <MembersTableList
        learningTeamMembers={learningTeamMembers}
        removeTeamMember={removeTeamMember}
      />
      <TeamMembersManagementNotifications />
    </div>
  );
};

export default TeamMembers;
